import React, { Fragment, useEffect, useState } from "react";
import NoteItem from "./noteItem";
import Box from "@mui/material/Box";
import AddNotes from "./addNote";
import Grid from "@mui/material/Grid";
import { useHistory } from "react-router-dom";
import Switch from "react-switch";
import axios from "axios";
import { getInstance } from '../config/token';
import {
  Button,
} from "react-bootstrap";
import Spinner from 'react-bootstrap/Spinner'


const NoteList = () => {
  const [notes, setNotes] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const [filteredNotes, setFilteredNotes] = useState([]);
  const [favouriteFilter, setFavouriteFilter] = useState(false);
  const [loading, setLoading] = useState(false);

  const history = useHistory();

  useEffect(() => {
    fetchMyNotes();
  }, []);

  useEffect(() => {
    fetchMyNotes();
  }, [favouriteFilter]);

  const onSubmit = (newNote) => {
    setFilteredNotes([newNote, ...notes]);
    setNotes([newNote, ...notes]);
    setIsModalOpen(false);
    setIsSuccess(true);
  };

  const fetchMyNotes = async () => {
    setLoading(true)
    let config = getInstance('POST', `/api/note_list`, { "favourite": favouriteFilter });
    axios(config)
      .then((res) => {
        setFilteredNotes(res.data)
        setLoading(false)
      })
      .catch((err) => {
        setLoading(false)
      })
  };

  const filterOnClick = () => {
    setFavouriteFilter(!favouriteFilter)
  };

  const closeNotePopup = () => {
    setIsModalOpen(false)
  }

  return (
    <Fragment>
      <div style={{ display: "inline" }}>

        <span style={{ fontWeight: "700", color: "#111111", verticalAlign : "text-bottom", marginRight : "10px" }}>Favorites Only</span> 
        <div style={{verticalAlign : "middle", display : "inline-block"}}>
        <Switch onChange={filterOnClick} checked={favouriteFilter} />
        </div>
        
        {/* <input
            type="text"
            name="title"
            style={{
              marginLeft: "5px",
              width: "fit-content",
              display: "inline",
              marginBottom: "1rem",
            }}
            className="form-control form-border-color"
            maxLength={255}
            placeholder="Search Here..."
            value={searchTicketSms}
            onChange={(e) => setSearchKey(e)}
          /> */}
        <Button
          as="a"
          // className="add-menu-sidebar"
          style={{ float: "right", marginBottom: "1rem", marginRight: "10px" }}
          data-toggle="modal"
          data-target="#addOrderModalside"
          onClick={() => setIsModalOpen(true)}
        >
          + New Note
        </Button>
      </div>

      <Box>
        {/* <Snackbar
        open={isSuccess}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        autoHideDuration={2000}
        onClose={() => setIsSuccess(false)}
      >
        <Alert variant="filled" severity="success">
          Note added successfully
        </Alert>
      </Snackbar> */}
        {loading ?
          <div
            style={{
              textAlign: "center",
              width: "100%",
              position: "absolute",
              marginBottom: "10px",
            }}
          >
            <Spinner animation="border" role="status">
              <span className="visually-hidden"></span>
            </Spinner>
          </div>
          :
          <Grid alignItems={"stretch"} container spacing={2}>
            {filteredNotes.length ? filteredNotes.map((note, index) => (
              <Grid item xs={12} md={4}>
                <NoteItem
                  note={note}
                  key={index}
                  // onDelete={onDelete}
                  onUpdate={fetchMyNotes}
                />
              </Grid>
            )) :
              <div
                style={{
                  textAlign: "center",
                  width: "100%",
                  position: "absolute",
                  marginBottom: "10px",
                }}
              >
                <span style={{ fontWeight: "700" }}>{"🎉 No Notes."}</span>
              </div>
            }
          </Grid>
        }
        {isModalOpen ?
          <AddNotes isModalOpen={isModalOpen} onSubmit={onSubmit} closeNotePopup={closeNotePopup} fetchMyNotes={fetchMyNotes} />
          : ""
        }
      </Box>
    </Fragment>
  );
}

export default NoteList;
